import { createMuiTheme } from '@material-ui/core';

const DHITheme = createMuiTheme({
  palette: {
    primary: {
      main: '#0B4566', // DHI Primary color
    },
    secondary: {
      main: '#00A4EC', // Automatically generated secondary color
    },
  },

  typography: {
    h6: {
      color: '#0B4566',
      fontSize: 18,
      backgroundColor: '#F2F5F7',
      padding: '8px 16px',
      borderTop: '1px solid #DBE4E9',
      borderBottom: '1px solid #DBE4E9',
    },
    body1: {
      fontSize: 14,
    },
  },
  drawerColor: '#ffffff',
  drawerWidth: '50vw',
  landingPage: {
    maxWidth: 1080,
    padding: '20vh, 0',
    media: {
      width: 540,
      height: 320,
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        width: 36,
        height: 36,
        padding: 0,
        '&:hover': {
          backgroundColor: '#F8F8F8',
          borderRadius: 'unset',
        },
      },
    },
  },
});

export default DHITheme;
